import React from 'react';
import { Navigate } from 'react-router-dom';
import { ApprovalRouting } from './ApprovalRouting';
import { canAccessApprovalRouting } from '../../utils/approvalRoutingAccess';

class Setting extends React.Component {
    render() {
        try {
            const userData = localStorage.getItem('user');
            if (!userData) {
                return <Navigate to="/login" replace />;
            }

            const user = JSON.parse(userData);
            
            if (!canAccessApprovalRouting(user)) {
                return (
                    <div className="container">
                        <div style={{ marginTop: '20px', padding: '20px', textAlign: 'center' }}>
                            <h4>Access Denied</h4>
                            <p>You do not have permission to access Approval Routing. This feature is only available for administrators.</p>
                        </div>
                    </div>
                );
            }

            return (
                <div className="container">
                    <div style={{ marginTop: '20px' }}>
                        <ApprovalRouting />
                    </div>
                </div>
            );
        } catch (error) {
            console.error('Error in Setting component:', error);
            return <Navigate to="/login" replace />;
        }
    }
}

export {Setting};